module.exports = __webpack_public_path__ + "static/media/cert-godaddy-white.ff1b784f.svg";